import { instance } from '../api/ApiRequest';
import { serverUrls } from '../variables';
import { User } from '../types/auth.types';

export const getUsers = async ({
  sort_by,
  order_by,
}: {
    sort_by?: string;
    order_by?: string;
} = {}) => {
  const paramsObj = {
    ...(order_by ? { order_by } : {}),
    ...(sort_by ? { sort_by } : {}),
  };

  const queryParams = new URLSearchParams(paramsObj);

  return await instance.get<User[]>(`${serverUrls.accounts}users/?${queryParams}`);
};

export const getSingleUser = async (id: number| undefined) => await instance.get(`${serverUrls.accounts}users/${id}/`);

export const singleUserUpdate = async (id: number | undefined, payload: any) => await instance.patch(`${serverUrls.accounts}users/${id}/`, payload);

export const inviteNewUser = async (email: string, payload: any) => await instance.post(`${serverUrls.accounts}users/invitations/`, {
  email,
  ...payload,
});
